export const validateNumber = (value: string | number) => {
  const parsedValue = Number(value);
  return !isNaN(parsedValue) && isFinite(parsedValue);
};
